// extracted by mini-css-extract-plugin
export default {"login_bg":"login_login_bg__zKrb4","login_submit":"login_login_submit__wGlyU"};